export default __webpack_public_path__ + "img/filter_SK.1ffb4c094ac49b619ab33d45cece462d.jpg";